// AI-CONTEXT: See docs/features/updates-log.md
// De uitgelichte verhalen: updates met een `highlight`-blok, die bovenaan de
// Updates-pagina als grote kaart staan en een eigen pagina krijgen.

import filterUpdates from './filterUpdates'
import isValidHighlight from './isValidHighlight'

/**
 * De uitgelichte verhalen die deze organisatie mag zien, nieuwste eerst.
 *
 * Bouwt op filterUpdates, zodat de modulepoort en de sortering er maar één keer
 * staan. Een verhaal met een half `highlight`-blok valt af in plaats van half
 * getoond te worden.
 *
 * @param {*} updates - De ruwe lijst uit updates.json
 * @param {Array<string>} [activeModules] - Modulecodes die de organisatie afneemt
 * @returns {Array<object>} Alleen de entries met een geldig verhaal
 */
const featuredUpdates = (updates, activeModules) =>
    filterUpdates(updates, activeModules).filter((update) => isValidHighlight(update.highlight))

/**
 * Eén uitgelicht verhaal, voor de detailpagina.
 *
 * Loopt bewust langs dezelfde poort: zonder deze controle zou de detailpagina
 * een omweg om de modulefilter heen zijn voor wie het id kent.
 *
 * @param {*} updates - De ruwe lijst uit updates.json
 * @param {Array<string>} [activeModules] - Modulecodes die de organisatie afneemt
 * @param {*} id - Het id uit de URL
 * @returns {object|null} De update, of null als hij niet bestaat of niet mag
 */
const findFeaturedUpdate = (updates, activeModules, id) => {
    if (typeof id !== 'string' || !id.trim()) return null
    return featuredUpdates(updates, activeModules).find((update) => update.id === id) || null
}

export { findFeaturedUpdate }
export default featuredUpdates
